// opervex-frontend/src/components/SearchHelp/index.js

import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import FilterAccordion from "../Filter/FilterAccordion";
import SearchHelpTable from "./SearchHelpTable";

const SearchHelp = ({ schema, autoFilter, showModal, setShowModal, onSelectItem, urlData, size, preFilters, noFilter }) => {
  const [data, setData] = useState([]);
  const [layout, setLayout] = useState(null);

  const fetchData = async () => {
    if (!layout && showModal) {
      setLayout(schema);
    }
  };

  useEffect(() => {
    fetchData(); // eslint-disable-next-line
  }, [showModal]);

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size={size ?? "xl"}>
      <Modal.Header closeButton>
        <Modal.Title>Pesquisar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FilterAccordion
          autoFilter={autoFilter}
          noFilter={noFilter}
          layout={layout || []}
          setData={setData}
          urlData={urlData}
          preFilters={preFilters}
        />

        {/* Tabela Dinâmica */}
        <SearchHelpTable modal={true} layout={layout || []} data={data || []} onSelectItem={onSelectItem} />
      </Modal.Body>
    </Modal>
  );
};

export default SearchHelp;
